// extracted by mini-css-extract-plugin
module.exports = {"bullet":"SliderPagination_bullet__r3Mqm","active":"SliderPagination_active__uby81","grow":"SliderPagination_grow__A2pYx","swiper":"SliderPagination_swiper__fXYb_"};